import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import Banner1 from '../assets/banner-1.webp';
import Banner2 from '../assets/banner-2.webp';
import Banner3 from '../assets/banner-3.webp';
import Banner4 from '../assets/banner-4.webp';

const Banner = () => {
  const [banners] = useState([
    {
      id: 0,
      image: Banner4,
      title: '',
      link: 'https://app.layer3.xyz/campaigns/zkcandy'
    },
    {
      id: 1,
      image: Banner1,
      title: 'Out Of The Nest',
      link: 'https://www.outofthenest.io/hatching'
    },
    {
      id: 2,
      image: Banner2,
      title: 'Candy Defense',
      link: 'https://app.candydefense.xyz/'
    },
    {
      id: 3,
      image: Banner3,
      title: 'PEPE Kingdom',
      link: 'https://app.pepekingdom.wtf/'
    },
    {
      id: 4,
      image: Banner4,
      title: '',
      link: 'https://app.layer3.xyz/campaigns/zkcandy'
    },
  ]);

  return (
    <div className="w-full h-48">

      <Swiper
        modules={[Autoplay, Pagination]}
        navigation={true}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        className="w-full h-full"
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.id}>
            {banner.link ? (
              <a
                href={banner.link}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full h-full block"
              >
                <div
                  className="w-full h-full bg-cover bg-center relative bg-top"
                  style={{ backgroundImage: `url(${banner.image})` }}
                >
                  {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                    <h3 className="text-white text-lg font-semibold">
                      {banner.title}
                    </h3>
                  </div> */}
                </div>
              </a>
            ) : (
              <div
                className="w-full h-full bg-cover bg-center relative bg-top"
                style={{ backgroundImage: `url(${banner.image})` }}
              >
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;